import React from 'react'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

import FilterWrapper from './filter/FilterWrapper'

const MapFilters = props => {
  if (!props.panelDisplayed.filter) return null

  let panelOffsetLeft = props.panelDisplayed.offsetLeft
  if (document.documentElement.offsetWidth - 528 < panelOffsetLeft) {
    panelOffsetLeft = document.documentElement.offsetWidth - 528
  }

  return (
    <>
      <div
        className='[ f-hidden:s ] SearchResultsFilters-overlay'
        style={{ top: 0 }}
        onClick={() => props.displayPanel({})}
      />
      <div
        className='[ f-d-flc f-c-ba-whi f-p-a-020 ] SearchResultsFilters-container'
        style={{ left: panelOffsetLeft }}>
        <div className='[ f-d-flr f-p-b-020 f-hidden:m f-hidden:l ] SearchResultsFilters-container-top'>
          <CTA
            type='text-primary'
            tag='a'
            className='[ f-t-body f-t-bold ]'
            onClick={() => props.removeFilter(props.panelDisplayed.filter)}>
            Zurücksetzen
          </CTA>
          <CTA
            type='icon'
            tag='a'
            className='SearchResultsFilters-close'
            onClick={() => props.displayPanel({})}>
            <Icon icon='close-16px' className='[ f-icon-030 f-c-st-neu200 ]' />
          </CTA>
        </div>
        <div
          className={`SearchResultsFilters-container-content ${
            props.panelDisplayed.filter === 'office_location'
              ? 'is-location'
              : ''
          }`}>
          <FilterWrapper
            filtersList={props.availableFilters.filter(
              filter => filter.name === props.panelDisplayed.filter
            )}
            updateQuery={props.updateQuery}
            params={props.params}
            locationParams={props.locationParams}
            setLocationParams={props.setLocationParams}
          />
        </div>
        <div className='[ f-d-flr f-p-t-020 ] SearchResultsFilters-container-bottom'>
          {props.panelDisplayed.isActive && (
            <CTA
              type='text-primary'
              tag='a'
              className='[ f-t-body f-t-bold f-hidden:s ]'
              onClick={() => props.removeFilter(props.panelDisplayed.filter)}
              wtData={{
                'CTA-click': {
                  label: 'filter-reset',
                  location: 'filter-panel'
                }
              }}>
              Zurücksetzen
            </CTA>
          )}
          <CTA
            type='block-primary'
            tag='a'
            className='SearchResultsFilters-cta'
            onClick={() => {
              props.displayPanel({})
              props.applyQuery()
            }}
            wtData={{
              'CTA-click': {
                label: 'filter-close',
                location: 'filter-panel'
              }
            }}>
            Anwenden
          </CTA>
        </div>
      </div>
    </>
  )
}

export default MapFilters
